import * as yup from 'yup';

export const createCalendarSchema = yup.object().shape({
  description: yup.string().required('La descripción es requerida'),
});
